export class ConversationThreadMessage {
    MessageType: string;
    SenderName: string;
    FormattedText: string;
    CreatedDate: Date;

    public static FixDates(item: ConversationThreadMessage) {
        item.CreatedDate = new Date(item.CreatedDate);
    }

}

export class ConversationThreadMessageArray extends Array<ConversationThreadMessage> {

    constructor(...items: ConversationThreadMessage[]) {
        super(...items);
        Object.setPrototypeOf(this, ConversationThreadMessage.prototype);
    }

    public static FixDates(item: ConversationThreadMessageArray) {
        item.forEach(x => ConversationThreadMessage.FixDates(x));
    }


}
